import React from 'react'
import PartnerLogo1 from '../../assets/images/sattva_partners/partner1.png';
import PartnerLogo2 from '../../assets/images/sattva_partners/partner2.png';
import PartnerLogo3 from '../../assets/images/sattva_partners/partner3.png';
import PartnerLogo4 from '../../assets/images/sattva_partners/partner4.png';
import PartnerLogo5 from '../../assets/images/sattva_partners/partner5.png';
import PartnerLogo6 from '../../assets/images/sattva_partners/partner6.png';


export default function Partners() {
    const logos = [PartnerLogo1, PartnerLogo2, PartnerLogo3, PartnerLogo4, PartnerLogo5, PartnerLogo6];
    return (
        <section id='partners' className="relative py-16">
            <div className="container">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h6 className="text-blue-600 text-base font-medium uppercase mb-2">Our Partners</h6>
                    <h3 className="mb-4 md:text-2xl text-xl font-medium dark:text-white">We partner with industry leaders</h3>
                    {/* <p className="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">Launch your campaign and benefit from our expertise on designing and managing conversion centered Tailwind CSS html page.</p> */}
                </div>

                <div className="overflow-hidden w-full py-8">
                    <div
                        className="flex items-center space-x-8"
                        style={{ animation: "scroll 25s linear infinite" }}
                    >
                        {logos.concat(logos).map((logo, index) => (
                            <div
                                key={index}
                                className="
          flex-shrink-0
          w-20 h-20 md:w-32 md:h-32
          bg-white/80
          rounded-full
          flex items-center justify-center
          shadow-md dark:shadow-gray-700
          transition-all duration-300
          hover:scale-105 hover:shadow-xl p-2
        "
                            >
                                <img
                                    src={logo}
                                    alt={`logo-${index}`}
                                    className=" rounded-lg
             w-auto object-contain
            transition-all duration-300
         
          "
                                />
                            </div>
                        ))}
                    </div>

                    {/* Animation */}
                    <style jsx>{`
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
  `}</style>
                </div>


            </div>
        </section>
    )
}
